import React from 'react'
import './index.css'

import App from './App'
import ReactDOM from 'react-dom/client'

ReactDOM.createRoot(
  document.getElementById("root"),
)
.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
